export default __webpack_public_path__ + "static/bianca-383266102acbb0509d4a2c2b1047560c.png";